import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {CompetitorResultsService} from "@services";
import {LANDING_ROUTE} from "../app-routing.module";
import {CompetitorResults} from "@model";

export const LiveResultsResolver: ResolveFn<Observable<CompetitorResults[] | null> |
  Promise<CompetitorResults[]> | CompetitorResults[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   competitorResultsService: CompetitorResultsService = inject(CompetitorResultsService),
   router: Router = inject(Router)): Observable<CompetitorResults[] | null> |
    Promise<CompetitorResults[]> | CompetitorResults[] => {
    let raceId: number | undefined = +route.queryParams['raceId'] ? +route.queryParams['raceId'] : undefined;
    if (raceId) {
        return competitorResultsService.getAllCompetitorResults(raceId).pipe(
          take(1),
          mergeMap((res: CompetitorResults[] | null | undefined) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    } else {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    }

  }
